
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { TeamModel } from './Identity.Api.Models.Team';
import { Model, ModelProperty } from 'models/Model';


export class TeamCustomCredentialModel extends Model<TeamCustomCredentialModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'teamId', type: 'guid', languageString: 'teamCustomCredential.property.teamId' },
		{ name: 'customCredential', type: 'string', languageString: 'teamCustomCredential.property.customCredential' },
		{ name: 'team', type: 'TeamModel', languageString: 'teamCustomCredential.property.team', isHidden: true, isObject: true, new: () => { return new TeamModel }, properties: () => { return TeamModel.classProperties } }
	];
	[key: string]: any;
	
	public teamId?: string;
	public customCredential: string;
	public team?: TeamModel;
    
	constructor(){
		super();
		this.teamId = undefined;
		this.customCredential = '';
		this.team = undefined;
		
	}
	getProperties(){
		return TeamCustomCredentialModel.classProperties;
	}
}

